import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreDiscoverCollectionsModule,
  DatastorePoolsModule,
  DatastorePredefinedDiscoverCollectionsModule,
  DatastoreUsersFollowModule,
} from '@freelancer/datastore/collections';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { MyListsComponent } from './my-lists.component';
import { UserListCreateButtonComponent } from './user-list-create-button.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreDiscoverCollectionsModule,
    DatastorePredefinedDiscoverCollectionsModule,
    DatastorePoolsModule,
    DatastoreUsersFollowModule,
    FeatureFlagsModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [MyListsComponent, UserListCreateButtonComponent],
  exports: [MyListsComponent, UserListCreateButtonComponent],
})
export class MyListsModule {}
